module.exports = __webpack_public_path__ + "img/报销申请@3x.657440e8.png";